import React, { useCallback, useEffect, useState } from 'react';

import ProtocolForm from './components/ProtocolForm';
import RecordTypeSelection from '../components/RecordTypeSelection';
import { useRecordTypesByUser } from '../../RecordType/hooks/useRecordTypesByUser';
import Loader from 'components/Loader';
import { Row, Button } from 'reactstrap';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useSocketCallAnswered } from 'components/Navbars/ServicePanel/ProtocolModal/hooks/useSocketCallAnswered';
import AssociateToProtocolModal from '../list/components/AssociateToProtocolModal';

function ProtocolCreationHandler(props) {
  const [selectedRecordTypeId, setSelectedRecordTypeId] = useState(null);
  const [shouldShowProtocols, setShouldShowProtocols] = useState(false);
  const { forceSaveProtocol, startCounter } = useSocketCallAnswered();
  const {
    recordTypes,
    isLoadingRecordTypes,
    getRecordTypesByUser,
    getAllRecordTypesFromProtocolEntity
  } = useRecordTypesByUser(entitiesName.PROTOCOL);
  const [isProtocolAssociationModalOpen, setIsProtocolAssociationModalOpen] =
    useState(false);

  useEffect(() => {
    if (props.fatherProtocol) {
      getAllRecordTypesFromProtocolEntity({
        showDisabled: false,
        entity: 'PROTOCOL'
      });
    } else {
      getRecordTypesByUser();
    }
  }, [getRecordTypesByUser]);

  useEffect(() => {
    const defaultData = props.modalActions?.defaultFormData;
    if (defaultData && Object.keys(defaultData).length > 0) {
      const recordTypeToOpenModal = defaultData.recordTypeId || 1;
      setSelectedRecordTypeId(recordTypeToOpenModal);
      setShouldShowProtocols(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.modalActions]);

  useEffect(() => {
    if (recordTypes && recordTypes.length === 1) {
      setSelectedRecordTypeId(recordTypes[0].id);
      setShouldShowProtocols(true);
    }
  }, [recordTypes]);

  const shouldShowRecordTypeSelection = useCallback(() => {
    if (isLoadingRecordTypes || !shouldShowProtocols) return true;
    return false;
  }, [isLoadingRecordTypes, shouldShowProtocols]);

  const handleOnSelectedRecordType = useCallback((recordTypeId) => {
    setSelectedRecordTypeId(recordTypeId);
    setShouldShowProtocols(true);
  }, []);

  useEffect(() => {
    if (selectedRecordTypeId && props?.setDisplayEndButton) {
      props.handleSelectedRecordType(selectedRecordTypeId);
    }
  }, [props, selectedRecordTypeId]);

  useEffect(() => {
    if (props.createSubProtocol === false) {
      setIsProtocolAssociationModalOpen(true);
    }
  }, [props.createSubProtocol]);

  const changeProtocol = (condition) => {
    props.setCreateSubProtocol(condition);
  };

  const render = () => {
    if (!recordTypes || !recordTypes.length)
      return (
        <Row className="justify-content-md-center">
          <Loader />
        </Row>
      );

    return shouldShowRecordTypeSelection() ? (
      <>
        {props?.setDisplayEndButton ? props.setDisplayEndButton(false) : ''}
        <RecordTypeSelection
          recordTypes={recordTypes}
          handleOnSelectedRecordType={handleOnSelectedRecordType}
        />
      </>
    ) : (
      <>
        {props?.setDisplayEndButton ? props.setDisplayEndButton(true) : ''}
        {props.isFromUpdate === true || props.isFromUpdate === 'true' ? (
          <>
            {props.createSubProtocol === null && (
              <>
                <h3>Escolher entre criar ou associar um protocolo existente</h3>
                <Button
                  type="button"
                  color="primary"
                  onClick={() => changeProtocol(false)}
                >
                  Associar a um protocolo existente
                </Button>

                <Button
                  type="button"
                  color="primary"
                  onClick={() => changeProtocol(true)}
                >
                  Criar um sub protocolo
                </Button>
              </>
            )}

            {props.createSubProtocol === false && (
              <AssociateToProtocolModal
                {...props}
                selectedRecordTypeId={selectedRecordTypeId}
                fatherProtocol={props.fatherProtocol}
                createdFrom={props.createdFrom ?? ''}
                isModalOpen={isProtocolAssociationModalOpen}
                onModalToggle={setIsProtocolAssociationModalOpen}
                onProtocolUpdate={props.onProtocolUpdate}
              />
            )}

            {props.createSubProtocol && (
              <ProtocolForm
                {...props}
                selectedRecordTypeId={selectedRecordTypeId}
                deafultDataAcctid={props?.modalActions?.defaultFormData?.acctid}
                forceSaveProtocol={forceSaveProtocol}
                startCounter={startCounter}
                createdFrom={props.createdFrom ?? ''}
                fatherProtocol={props.fatherProtocol}
                onProtocolUpdate={props.onProtocolUpdate}
              />
            )}
          </>
        ) : (
          <ProtocolForm
            {...props}
            selectedRecordTypeId={selectedRecordTypeId}
            deafultDataAcctid={props?.modalActions?.defaultFormData?.acctid}
            forceSaveProtocol={forceSaveProtocol}
            startCounter={startCounter}
            createdFrom={props.createdFrom ?? ''}
            fatherProtocol={props.fatherProtocol}
            onProtocolUpdate={props.onProtocolUpdate}
          />
        )}
      </>
    );
  };

  return render();
}

export default ProtocolCreationHandler;
